import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css!';

class SliderHomepage {

  constructor(){
    this.components = document.querySelectorAll('[data-trigger="slider-homepage"]');
    this._init();
  }

  _init(){

    if( this.components ){
      for (let component of this.components) {
        let swiper = null;
        const slideNumber = component.querySelectorAll('.slider-homepage__slide').length;
          
        const firstImage = component.querySelector('img');
        if(firstImage){
          firstImage.onload = ()=> {
            if(swiper){
              swiper.update();
            }
          };
        }

        swiper = new Swiper(component, {
          navigation: {
            nextEl: component.querySelector('[data-trigger="slider-homepage-next"]'),
            prevEl: component.querySelector('[data-trigger="slider-homepage-prev"]'),
          },
          pagination: {
            el: component.querySelector('[data-trigger="slider-homepage-pagination"]'),
            type: 'bullets',
            clickable: true
          },
          speed: 400,
          autoplay        : {
            delay: 5000,
          },
          loop            : true,
          preloadImages: false,
          lazy: {
            loadOnTransitionStart: true,
          }
        });

        if (slideNumber === 1) {
          swiper.autoplay.stop();
        }

      }
    }
  }

}

export const sliderHomepage = new SliderHomepage();